import {Avatar, message} from 'antd'
import getTitle from 'helpers/getTitle'
import _ from 'lodash'
import Translate from 'modules/local/Translate'
import React, {useContext} from 'react'
import {NullAsDefault, renderIf,} from 'views/Shared'
import {renderIfElse} from "../../../Shared";
import {FaAddressCard, FaUserGraduate} from "react-icons/fa6";
import {renderMetadataMissing} from "../../../../components/DynamicFields/functions/renderMetadataMissing";
import classNames from "classnames";
import copyToClipboard from "copy-to-clipboard";
import {IdentifierTypes} from "../../../AppLocals/appFieldTypes";
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import {IoCopyOutline} from "react-icons/io5";
import {DoubleValueItem} from 'components/common/DoubleValueItem'
import {GoDash, GoDotFill} from "react-icons/go";
import useTranslate from "../../../../modules/local/useTranslate";
import getAliasName from "../../../../helpers/getAliasName";
import getLinkToDetail from "../../../../helpers/getLinkToDetail";
import {Link} from "react-router-dom";

const WrapperClassStudent = ({item, index, children}) => {
    const t = useTranslate()
    const {isSm} = useContext(LayoutContext)

    const {student} = item ?? {}

    const {
        avatar,
        edit,
        user,
        student_idcode,
        identifier_code,
        identifier_type,
        prefix_title,
        patron_saint_name,
        fullname,
    } = student ?? {}

    return (
        <div key={index} className="p-4 flex flex-col custom-item-render relative list-item">
            <div className="mb-2 pb-2 border-b border-color-100 flex items-center gap-2">
                <Avatar
                    size={40}
                    src={avatar}
                    icon={<FaUserGraduate size={15} className="text-color-500"/>}
                    className="flex flex-center background-200"
                />
                <div className="flex flex-col flex-1">
                    <div className="font-bold text-base text-gray-800 leading-snug">
                        {renderIf(
                            patron_saint_name,
                            <span className="mr-1 font-medium text-sm text-gray-600 111-111">
                                {getAliasName(student, 'patron_saint')}
                            </span>
                        )}
                        {fullname}
                    </div>
                    <div className="flex items-center gap-6">
                        {renderIf(
                            student_idcode,
                            <div className="text-color-400 text-xs">
                                <span className="whitespace-no-wrap">
                                    {isSm ? '#' : `${t('student code')} : `}
                                </span>
                                <span
                                    onClick={() => {
                                        copyToClipboard(student_idcode)
                                        message.info(t('copied'))
                                    }}
                                    className="font-mono font-semibold text-blue-500 hover:text-blue-700 cursor-pointer">
                                    {student_idcode}
                                    <IoCopyOutline size={12} className="ml-1"/>
                                </span>
                            </div>
                        )}
                        {renderIf(
                            (edit === true && identifier_code),
                            <div className="flex items-center text-color-400 text-xs gap-1">
                                {isSm ?
                                    <FaAddressCard size={12} className="mr-1"/> :
                                    <span className="mr-1 whitespace-no-wrap">
                                        {`${t(_.find(IdentifierTypes, {value: identifier_type})?.label)} : `}
                                    </span>
                                }
                                <span
                                    onClick={() => {
                                        copyToClipboard(identifier_code)
                                        message.info(t('copied'))
                                    }}
                                    className="font-mono font-semibold text-blue-500 hover:text-blue-700 cursor-pointer">
                                    {identifier_code}
                                    <IoCopyOutline size={12} className="ml-1"/>
                                </span>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            {children}
        </div>
    )
}

export const renderCourseStudent = ({detail = true, renderActions = NullAsDefault, renderContextMenu = NullAsDefault} = {}) => (item, index) => {
    const {
        student,
        result_status,
        medal_awards = [],
        diocese,
        parish,
        registered_classes = [],
        registered_subjects = [],
    } = item ?? {}

    const {
        contact_phone,
        contact_email,
    } = student ?? {}

    let label_status
    let color_status
    switch (result_status) {
        case 1:
            label_status = 'passed'
            color_status = 'text-green-600'
            break
        case 0:
            label_status = 'failed'
            color_status = 'text-red-600'
            break
        default:
            label_status = 'not assessed yet'
            color_status = 'text-color-300'
            break
    }

    return (
        <Translate key={index}>
            {(t) => (
                <WrapperClassStudent item={item} index={index}>
                    <div className="ml-3 flex flex-col flex-1">
                        {renderIf(
                            _.some([diocese, parish]),
                            <DoubleValueItem
                                showIcon={true}
                                labelFirst="parish"
                                valueFirst={parish?.name}
                                labelSecond={diocese && " - " || ''}
                                valueSecond={diocese?.fullname}
                                className="italic tracking-wider"
                            />
                        )}
                        {renderIf(
                            registered_subjects?.length > 0,
                            <div className="space-x-1 italic tracking-wider">
                                <GoDotFill size={10} className="text-color-500" />
                                <span className="text-color-400 whitespace-no-wrap">
                                    {`${t('subjects registered')} :`}
                                </span>
                                {renderIfElse(
                                    registered_subjects.length > 0,
                                    registered_subjects.map((e, i) => (
                                        <span key={i} className="font-semibold text-color-100">
                                            <GoDash size={10} className="mr-1 text-color-100" />
                                            {getTitle(e)}
                                            {i < registered_subjects.length - 1 && ', '}
                                        </span>
                                    )),
                                    <span className="font-semibold text-color-100">
                                        {t('not update')}
                                    </span>
                                )}
                            </div>
                        )}
                        {renderIf(
                            registered_classes.length > 0,
                            <div className="space-x-1 italic tracking-wider">
                                <GoDotFill size={10} className="text-color-500" />
                                <span className="text-color-400 whitespace-no-wrap">
                                    {`${t('learn in the class')} : `}
                                </span>
                                {registered_classes.map((e, i) => (
                                    <Link key={i} to={getLinkToDetail} className="font-bold text-color-000 no-underline">
                                        {getTitle(e)} {i < registered_classes.length - 1 && ', '}
                                    </Link>
                                ))}
                            </div>
                        )}
                        {renderIf(
                            medal_awards?.length > 0,
                            <div className="space-x-1 italic tracking-wider">
                                <GoDotFill size={10} className="text-color-500" />
                                <span className="text-xs text-color-400 whitespace-no-wrap">
                                    {`${t('certification awarded')} : `}
                                </span>
                                {medal_awards.map((e, i) => (
                                    <span key={i} className="font-semibold text-xs text-primary-700 italic">
                                        {getTitle(e.medal)} {i < medal_awards.length - 1 && ', '}
                                    </span>
                                ))}
                            </div>
                        )}
                        {renderIf(
                            item?.course?.edit,
                            renderMetadataMissing(_.get(item, 'metadata', []))
                        )}
                        {renderActions(item)}
                    </div>
                    {renderIf(
                        (detail && result_status !== null),
                        <span
                            style={{bottom: 10, right: 20}}
                            className={classNames("absolute font-bold text-xs tracking-wide uppercase opacity-80", color_status)}>
                            {t(label_status)}
                        </span>
                    )}
                    {renderIf(
                        renderContextMenu,
                        <div className="absolute top-5 right-5 contextIcon 22-22">
                            {renderContextMenu(item)}
                        </div>
                    )}
                </WrapperClassStudent>
            )}
        </Translate>
    )
}

export const renderCourseStudentWithSubject = ({renderActions = NullAsDefault, renderContextMenu = NullAsDefault} = {}) => (item, index) => {
    const {
        registered_subjects = [],
        registered_classes = [],
    } = item ?? {}

    return (
        <Translate key={index}>
            {(t) => (
                <WrapperClassStudent item={item} index={index}>
                    <div className="ml-3 flex flex-col flex-1">
                        <div className="flex-1 space-x-1 text-xs italic">
                            <GoDotFill size={10} className="text-color-500" />
                            <span className="text-color-500 whitespace-no-wrap italic">
                                {`${t('subjects registered')} :`}
                            </span>
                            {renderIfElse(
                                registered_subjects.length > 0,
                                registered_subjects.map((e, i) => (
                                    <span key={i} className="font-semibold text-color-100">
                                        {getTitle(e)} {i < registered_subjects.length - 1 && ', '}
                                    </span>
                                )),
                                <span className="font-semibold text-color-100">
                                    {t('not update')}
                                </span>
                            )}
                        </div>
                        {renderIf(
                            registered_classes.length > 0,
                            <div className="space-x-1 text-xs italic">
                                <GoDotFill size={10} className="text-color-500" />
                                <span className="text-color-500 whitespace-no-wrap">
                                    {`${t('learn in the class')} : `}
                                </span>
                                {registered_classes.map((e, i) => (
                                    <Link key={i} to={getLinkToDetail} className="font-bold text-color-000 no-underline">
                                        {getTitle(e)} {i < registered_classes.length - 1 && ', '}
                                    </Link>
                                ))}
                            </div>
                        )}
                    </div>
                    {renderIf(
                        renderContextMenu,
                        <div className="absolute top-5 right-0 contextIcon">
                            {renderContextMenu(item)}
                        </div>
                    )}
                </WrapperClassStudent>
            )}
        </Translate>
    )
}